<pargo-router-link [class]="className" [routerLink]="routerLink" [queryParams]="queryParams">
  <div class="cta__clicked" *ngIf="clicked && this.type === 'button'"></div>
  <mat-icon class="cta__icon" [svgIcon]="iconType ? icon : undefined" *ngIf="icon">
    {{!iconType ? icon : undefined}}
  </mat-icon>
  {{label}}
</pargo-router-link>
